(() => {
  const configElement = document.getElementById('bolleku-delivery-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const quotedIds = new Set(config.productIds.map(String));
  const root = window.Shopify.routes.root;
  let pending;
  let readyToSubmit = false;
  let cartHasQuote = config.initialCartHasQuote;

  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {
      signal: AbortSignal.timeout(10000),
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { signal: AbortSignal.timeout(10000), headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(config.error);
    const cart = await response.json();
    if (cart.errors || cart.status) throw new Error(config.error);
    return cart;
  };

  const sync = () => {
    if (pending) return pending;
    pending = (async () => {
      let cart = await request('cart.js');
      for (let pass = 0; pass < 100; pass += 1) {
        const item = cart.items.find(line =>
          quotedIds.has(String(line.product_id)) &&
          line.properties?.[config.property] !== config.value
        );
        if (!item) {
          cartHasQuote = cart.items.some(line => quotedIds.has(String(line.product_id)));
          return cart;
        }
        cart = await request('cart/change.js', {
          id: item.key,
          properties: { ...item.properties, [config.property]: config.value }
        });
      }
      throw new Error(config.error);
    })().finally(() => { pending = undefined; });
    return pending;
  };

  const showError = () => {
    const element = document.getElementById('cart-errors') ||
      document.getElementById('CartDrawer-CartErrors');
    if (element) {
      element.setAttribute('role', 'alert');
      element.textContent = config.error;
    }
  };

  document.addEventListener('submit', async event => {
    const form = event.target;
    const submitter = event.submitter;
    if (readyToSubmit || !form.matches('form[action*="/cart"]') ||
        submitter?.name !== 'checkout' || !cartHasQuote && !document.querySelector('[data-bolleku-quoted]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitter.disabled = true;
    try {
      await sync();
      submitter.disabled = false;
      readyToSubmit = true;
      form.requestSubmit(submitter);
    } catch {
      submitter.disabled = false;
      showError();
    } finally {
      readyToSubmit = false;
    }
  }, true);

  const prepare = () => {
    if (!cartHasQuote && !document.querySelector('[data-bolleku-quoted]')) return;
    const accelerated = document.querySelector('.cart__dynamic-checkout-buttons');
    if (accelerated) accelerated.hidden = true;
    sync().then(() => {
      if (accelerated) accelerated.hidden = false;
    }).catch(showError);
  };
  prepare();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, prepare);
  }
})();
